import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CountersContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getContadores(id: string): Observable<any> {
    return this.getContadoresContents(id).pipe(
      map(res => this.buildResponseCounterObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryContadoresContents[0].data;
  }

  private getContadoresContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryContadoresContents(filter: "id eq '${id}'") {
          data {
            titulo {
              iv
            }
            subtitulo {
              iv
            }
            imagem {
              iv {
                url
              }
            }
            contadores {
              iv {
                descricao
                imagem {
                  url
                }
                valor
                scale
              }
            }
            botoes {
              iv {
                titulo
                cores
                uRL
                modal {
                  id
                }
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseCounterObject(response: any) {
    let counters = [];
    let buttons = [];

    if (response.contadores) {
      counters = response.contadores.iv.map(counter => {
        return {
          limit: counter.valor,
          scale: counter.scale,
          icon:
            counter.imagem && counter.imagem[0] ? counter.imagem[0].url : '',
          description: counter.descricao
        };
      });
    }

    if (response.botoes) {
      buttons = response.botoes.iv.map(button => {
        let externalURL = false;
        if (button.uRL) {
          if (button.uRL.indexOf('http') >= 0) {
            externalURL = true;
          }
        }
        return {
          modal: button.modal && button.modal[0] ? button.modal[0].id : '',
          color: button.cores,
          title: button.titulo,
          url: button.url,
          router: externalURL ? null : button.uRL ? button.uRL : null,
          hrefTarget: externalURL ? '_blank' : null
        };
      });
    }

    return {
      title: response.titulo ? response.titulo.iv : response.titulo,
      subtitle: response.subtitulo ? response.subtitulo.iv : response.subtitulo,
      img:
        response.imagem && response.imagem.iv && response.imagem.iv[0]
          ? response.imagem.iv[0].url
          : '',
      counters,
      buttons
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
